<template>
  <div>
    <template  v-if="!this.kombox.id" class="media">
      <div class="media-body media-right text-right">
        <button 
          title="Neuer Eintrag"
          type="button" class="btn btn-link" 
          @click="editModus = true">
          Neue Kombox
        </button>
      </div>
    </template >
    <template v-else class="media">
      <div class="media-body ">
        <div class="media">
          <div class="media-left media-middle" :title="KomboxConf.TYPES[kombox.type].SYMBOL.TITLE">
              <span class="glyphicon" v-bind:class="[KomboxConf.TYPES[kombox.type].SYMBOL.CLASS, KomboxConf.ACLS[kombox.acl].SYMBOL.CLASS]"></span>
          </div>
          <a class="media-body cc-kombox-body "
             href=""   
             :title="kombox.content"
             @click="onClickContent($event)"
             >
              <strong v-if="kombox.acl == 3" >*******</strong>
              <strong v-else class="">{{contentView}}</strong>
              <br>
              <small class="">{{kombox.description}}</small>
          </a>
        </div>
      </div>    

      <div class="media-right text-right media-middle">
        <button v-show="kombox.shippingActiv > 0"
              type="button" class="btn btn-xs btn-default" 
              :class="{'btn-success': shippingAktive}" 
              @click="onClickShipping">
              <i v-if="['8','9','10'].indexOf(kombox.type) > -1" class="fa fa-clock-o" aria-hidden="true"></i>
              <span v-else class="glyphicon glyphicon-send"></span>
        </button>

        <button type="button"
                title="Eintrag bearbeiten"
                class="btn  btn-link cc-btn-menue"
                v-on:click="editModus = true">
                <span class="glyphicon glyphicon-option-vertical"></span>
        </button>

      </div>

  
    </template >

    <cc-kombox-modal 
      v-if="editModus" 
      :kombox="kombox"  
      @cancel="cancel"
      @remove="remove"
      @save="save">
    </cc-kombox-modal>

    <cc-extern-site 
      v-if="showExternSite" 
      :type="kombox.type"  
      :content="kombox.content"  
      @cancel="showExternSite = false"
      @commit="showExternSite = false">
    </cc-extern-site>

    <cc-phone-tool 
      v-if="showPhoneTool" 
      :kombox="kombox"  
      :content="kombox.content"  
      @close="showPhoneTool = false">
    </cc-phone-tool>

  </div>
</template>



<script>

import KomboxCommon from './common/kombox.common'
import KomboxModal from './KomboxModal.vue'
import ExternSite from './ExternSite.vue'
import PhoneTool from './PhoneTool.vue'

export default {
  
  extends: KomboxCommon,
  
  components: {
    'cc-kombox-modal': KomboxModal,
    'cc-extern-site': ExternSite,
    'cc-phone-tool': PhoneTool,
  },
  
  
  data () {
    return {
      shippingAktive: false,
      showExternSite: false,
      showPhoneTool: false,
    }
  },
  
  
  created: function () {
    this.emitShipping(this.isShippingActiv(this.kombox), this.kombox);
  },
  
  computed: {
    contentView: function () {
        if(this.kombox.type < 4){ // Tel mobil email und fax keine Änderung 
          return this.kombox.content
        }else{ // sonst nach dem ersten leerzeichen anzeigen
          let a_content = _.trim(this.kombox.content).split(/ +/);
          return (typeof a_content[1] == 'string') ?  this.kombox.content.substring(a_content[0].length) : a_content[0];
        }
    },
  
  },
  
  methods: {
    
    onClickContent: function (event) {
        event.preventDefault();
        event.stopPropagation();
      
       if( ['0','1'].indexOf(this.kombox.type) > -1 ){ //Telefon, Mobile
          this.showPhoneTool = true;
          return;
        }
  
       if( ['4','11','12'].indexOf(this.kombox.type) > -1 ){ //Web, Download, Tabelle
          this.showExternSite = true;
          return;
        }

       if( this.kombox.type == '14' ){ //externe Webseite
          window.open(_.trim(this.kombox.content).split(/ +/)[0], '_blank');
          return;
        }
      
      
    },
    
    
    // Overridden 
    onInsert: function (kombox) {
      this.emitShipping(this.isShippingActiv(kombox), kombox);
      this.$emit('insert', kombox);
    },
  
    // Overridden 
    onUpdate: function (kombox) {
      this.emitShipping(this.isShippingActiv(kombox), kombox);
      this.$emit('update', kombox);
    },
  
    // Overridden 
    onCancel: function (kombox) {
      //this.$emit('cancel', kombox);
    },
  
    // Overridden 
    onRemove: function (kombox) {
      this.emitShipping(false, kombox);
      this.$emit('remove', kombox);
    },
  
    onClickShipping: function () {
      this.emitShipping(!this.shippingAktive, this.kombox);
      $('.cc-kombox-list').find('.btn-default').css("background-color","");

    },
    
    emitShipping: function (shippingState, kombox) {
      if(this.shippingAktive != shippingState){
        this.shippingAktive = shippingState;
        if(shippingState){
          this.$emit('add-shipping', kombox);
        }else{
          this.$emit('remove-shipping', kombox);
        }
      }
    },
    
  }
  
}
</script>



<style scoped>

  small{
    color: gray;
  }
  
.shorten-long-text{
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}  
  
.acl-public{
    color: #00b400;
  }
  
  .acl-intern{
    color: #dacd00;
  }

  .acl-privat{
    color: #be0000;
  }

  .btn{
    padding: 4px 10px;
  }
  
  .cc-btn-menue{
    padding-left: 5px;  
    padding-right: 0px;  
  }

  .media{
    margin-top: 0px;
  }
  
  
  .media-right{
    white-space: nowrap;
  }

  .media-left{
    padding-left: 5px;
  }
  
  .cc-kombox-typ{
    padding-bottom: 30px;
  }
  
  .cc-kombox-body{
    border-left: 0px solid red;
    padding-left: 8px;
    line-height: 1.1em;
  
    /* https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */  
    word-break: break-word;

    /* Alternativ text Abschneiden, funktioniert nicht dynamisch 
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    */
  }
  
.media-left .glyphicon {
    padding-right: 0px;
    font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// Kombox.vue?594aef32